import { render } from "./RegistrarReports.vue?vue&type=template&id=12f33ae0"
import script from "./RegistrarReports.vue?vue&type=script&lang=js"
export * from "./RegistrarReports.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__